import React, { useState, useEffect, useCallback } from 'react';
import { Box } from '@/shared/ui/box';
import { BodyTextMediumB } from '@/shared/ui/typography2';
import { useScopedI18n } from '@locales/client';
import { Button } from '@/shared/ui/form/button';
import { Form, Field } from 'react-final-form';
import { FormField } from '@/shared/ui/form/form-field';
import { useAuth } from '@/features/auth-managment/model/auth-context';
import { validate } from '@/flat-pages/promocodes/ui/promocodes';
import { ActivationCode } from './styles';
import { useDebounce } from '@/shared/hooks';

export const ActivationCodeBlock = ({ bgMod = false }) => {
  const [codeView, setCodeView] = useState(false);
  const { formWelcomBanner, setFormWelcomBanner } = useAuth();
  const errorLoc = useScopedI18n('bonus.promocode');
  const tCard = useScopedI18n('bonus.card');
  const [localCode, setLocalCode] = useState(formWelcomBanner?.promocode || '');
  const debouncedCode = useDebounce(localCode, 500);

  // const isValidCode = useCallback((code) => {
  //   return code && code.length >= 5 && /^[A-Z0-9]+$/.test(code);
  // }, []);

  useEffect(() => {
    if (formWelcomBanner?.promocode) {
      setCodeView(true);
    }
  }, [formWelcomBanner?.promocode]);

  useEffect(() => {
    // if (isValidCode(debouncedCode)) {
    setFormWelcomBanner((prev) => ({
      ...prev,
      promocode: debouncedCode.toUpperCase(),
    }));
    // }
  }, [debouncedCode, setFormWelcomBanner]);

  const validation = validate(errorLoc);

  return (
    <ActivationCode>
      {!codeView ? (
        <Box $width="max-content" $margin="auto">
          <Button
            type="button"
            onClick={() => setCodeView(true)}
            fill
            variant="black"
          >
            <Box $padding="5px 14px">
              <BodyTextMediumB>
                {tCard('i_have_an')}{' '}
                {bgMod ? (
                  <span style={{ color: '#FF6601' }}>
                    {tCard('activation_code')}
                  </span>
                ) : (
                  tCard('activation_code')
                )}
              </BodyTextMediumB>
            </Box>
          </Button>
        </Box>
      ) : (
        <Form
          initialValues={{ code: formWelcomBanner?.promocode || '' }}
          validate={validation}
          onSubmit={() => {}}
          render={({ values }) => {
            useEffect(() => {
              if (values.code !== localCode) {
                setLocalCode(values.code || '');
              }
            }, [values.code]);

            return (
              <Box $maxWidth={bgMod ? '100%' : '218px'} $margin="auto">
                <Field
                  name="code"
                  component={FormField}
                  type="text"
                  autoComplete="off"
                  placeholder="Enter code"
                  parse={(value) => (value ? value.toUpperCase() : value)}
                  bgColor={bgMod ? '#27262B' : '#131315'}
                  placeholderColor="#AFAFAF"
                />
              </Box>
            );
          }}
        />
      )}
    </ActivationCode>
  );
};
